import { formatDate } from "@telerik/kendo-intl";

/**
 *
 * @param {Array} data
 * @param {import("@progress/kendo-react-grid").GridColumnProps[]} columns
 * @param {import("i18next").TFunction} columns
 */
export function excelDataNormalize(data, columns, t) {
  const booleanColumns = columns.filter((d) => d.type === "boolean");
  const activeColumns = columns.filter((d) => d.type === "active");
  const tColumns = columns.filter((d) => d.tKey);
  var dateColumns = columns.filter(
    (a) => a.type === "date" || a.filter === "date"
  );
  var dateTimeColumns = columns.filter(
    (a) => a.type === "datetime" || a.filter === "datetime"
  );
  return data.map((row) => {
    booleanColumns.forEach((grid) => {
      if (row[grid.field]) {
        row[grid.field] = t("yes_no_data", { returnObjects: true }).find(
          (a) => a.value === row[grid.field]
        )?.text;
      }
    });
    activeColumns.forEach((grid) => {
      if (row[grid.field]) {
        row[grid.field] = t("ACTIVE_PASSIVE_DATA", {
          returnObjects: true,
        }).find((a) => a.value === row[grid.field])?.text;
      }
    });
    tColumns.forEach((grid) => {
      if (row[grid.field]) {
        row[grid.field] = t(grid.tKey, { returnObjects: true }).find(
          (a) => a.value === row[grid.field]
        )?.text;
      }
    });
    dateColumns.forEach((dateColumn) => {
      if (row[dateColumn.field]) {
        if (new Date(row[dateColumn.field]).toString() !== "Invalid Date") {
          row[dateColumn.field] = formatDate(
            new Date(row[dateColumn.field]),
            "dd/MM/yyyy"
          );
        }
      }
    });
    dateTimeColumns.forEach((dateTimeColumn) => {
      if (row[dateTimeColumn.field])
        if (new Date(row[dateTimeColumn.field]) !== "Invalid Date")
          row[dateTimeColumn.field] = formatDate(
            new Date(row[dateTimeColumn.field]),
            "dd/MM/yyyy HH:mm:ss"
          );
    });
    return row;
  });
}
